import React from 'react'

import { withRouter } from 'react-router-dom';

import { Section, Text, Properties, Table, Index, InfosBar, SubscriptionDeadline, Empty, TextGroup, ExternalLink, Version } from 'components';
import { Container, Icon, Button } from 'semantic-ui-react';

import { ModalOptions, ModalClinic, ModalLinkDevice } from 'modals';

import { Typeof, Functions } from 'utils';
import { API } from 'services';

import moment from 'moment';


//--Constants
const DEVICES_PER_PAGE = 10;

class PaneInformations extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      devices: props.devices,
      showClinicEditModal: false,
      showClinicDeleteModal: false,
      showDeviceLinkModal: false,
      deviceSearchCriteria: ''
    };

    this.toggleClinicEditModal = this.toggleClinicEditModal.bind(this);
    this.handleCloseClinicEditModal = this.handleCloseClinicEditModal.bind(this);

    this.toggleClinicDeleteModal = this.toggleClinicDeleteModal.bind(this);
    this.handleCloseClinicDeleteModal = this.handleCloseClinicDeleteModal.bind(this);

    this.toggleDeviceLinkModal = this.toggleDeviceLinkModal.bind(this);
    this.handleCloseDeviceLinkModal = this.handleCloseDeviceLinkModal.bind(this);

    this.handleDeviceSearch = this.handleDeviceSearch.bind(this);
    this.handleDeviceSelect = this.handleDeviceSelect.bind(this);
  }

  toggleClinicEditModal() {
    this.setState({
      showClinicEditModal: !this.state.showClinicEditModal
    });
  }

  handleCloseClinicEditModal(edit) {

    if(Typeof.object(edit)) {

      //Refresh
      this.props.onModelChange(edit);
    }

    //Hide modal
    this.toggleClinicEditModal();
  }

  toggleClinicDeleteModal() {

    //Show modal
    this.setState({
      showClinicDeleteModal: !this.state.showClinicDeleteModal
    });
  }

  handleCloseClinicDeleteModal(result, setProcessing) {

    if(result === ModalOptions.OPTION_YES) {

      setProcessing(result);

      API.delete(`/clinics/${this.props.clinic.id}`)
        .then(() => {

          //Go back to clinics list
          this.props.history.push('/clinics');
        });

    }

    //Hide modal
    this.toggleClinicDeleteModal();
  }

  toggleDeviceLinkModal() {

    //Show modal
    this.setState({
      showDeviceLinkModal: !this.state.showDeviceLinkModal
    });
  }

  handleResendInvitationEmail() {

    API.post(`/clinics/${this.props.clinic.id}/send_activation_email`)

  }

  handleCloseDeviceLinkModal(device) {

    if(Typeof.object(device)) {

      let devices = [...this.state.devices];
      devices.push(device);

      this.setState({
        devices: devices
      });
    }

    //Hide modal
    this.toggleDeviceLinkModal();
  }

  handleDeviceSearch(criteria) {

    this.setState({
      deviceSearchCriteria: criteria
    });

  }

  handleDeviceSelect(device) {

    //Navigate to device page
    this.props.history.push(`/devices/${device.id}`);
  }

  render() {

    const { clinic } = this.props;
    const { devices } = this.state;

    let properties = [
      {
        name: 'Nom',
        value: <Text style={{"capitalize" : true}}>{clinic.name}</Text>
      },
      {
        name: 'Adresse e-mail',
        value: (
          <div>
            <Button content="Envoyer à nouveau le mail d'activation" onClick={this.handleResendInvitationEmail()} />
              <ExternalLink target={`mailto:${clinic.email}`}>
            <Icon name="mail" />
            {clinic.email}
          </ExternalLink>

            </div>
          
        )
      },
      {
        name: 'Numéro de tél.',
        value: (
          <ExternalLink target={`tel:${clinic.phone}`}>
            <Icon name="phone" />
            {Functions.formatPhone(clinic.phone)}
          </ExternalLink>
        )
      },
      {
        name: 'Adresse',
        value: clinic.address
      },
      {
        name: 'Code postal',
        value: clinic.zip_code
      },
      {
        name: 'Ville',
        value: clinic.city
      }
    ];

    let columns = [
      {
        id: 'id',
        header: '#',
        value: (device) => device.id,
        render: (device, value) => <Index value={value} />,
        fit: true
      },
      {
        id: 'version',
        header: 'Version',
        value: (device) => [device.app_version, device.ios_version],
        render: (device, versions) => {

          return (
            <TextGroup mode="rows">

              {/* App */}
              <Text style={{"mono" : true}}>
                <Icon name="tablet" />

                {Typeof.string(versions[0]) ? (
                  <Version version={versions[0]} />
                ) : (
                  <Empty />
                )}

              </Text>


              {/* iOS */}
              <Text style={{"mono" : true}}>
                <Icon name="apple" />

                {Typeof.string(versions[1]) ? (
                  <Text style={{"mono" : true}}>{versions[1]}</Text>
                ) : (
                  <Empty />
                )}

              </Text>

            </TextGroup>
          )
        }
      },
      {
        id: 'update_date',
        header: "Date d'installation",
        value: (device) => Typeof.string(device.update_date) ? moment(device.update_date).format('DD/MM/YYYY HH:mm:ss') : undefined,
        render: (device) => Typeof.string(device.update_date) ? <Text style={{"mono" : true}}>{moment(device.update_date).format('[Le] DD/MM/YYYY [à] HH:mm:ss')}</Text> : <Empty />,
        fit: true
      },
      {
        id: 'subscription_deadline',
        header: "Date limite d'abonnement",
        value: (device) => Typeof.string(device.subscription_deadline) ? moment(device.subscription_deadline).format('DD/MM/YYYY HH:mm:ss') : undefined,
        render: (device) => Typeof.string(device.subscription_deadline) ? <SubscriptionDeadline date={device.subscription_deadline} /> : <Empty />,
        fit: true
      }
    ];

    return (

      <React.Fragment>
        {/* Informations */}

        <Container>

          <Section title="Informations" actions={[
            <Button icon="edit" circular onClick={this.toggleClinicEditModal} key={0} />,
            <Button icon="trash" circular color="red" onClick={this.toggleClinicDeleteModal} key={1} />
          ]}>

            <Properties properties={properties} />

          </Section>

        </Container>

        {/* Devices */}
        <Container>

          <Section title="Valises" onSearch={this.handleDeviceSearch} actions={[
            <Button icon="add" content="Associer" onClick={this.toggleDeviceLinkModal} />
          ]}>

            {devices.length > 0 ? (

              <React.Fragment>

                {/* Number of available device */}
                <InfosBar mode="column">
                  <span>{devices.length > 1 ? `${devices.length} valises associées` : '1 valise associée'}</span>
                </InfosBar>

                {/* Devices table */}
                <Table columns={columns}
                  criteria={this.state.deviceSearchCriteria}
                  items={devices}
                  itemsPerPage={DEVICES_PER_PAGE}
                  onSelect={this.handleDeviceSelect}
                  messageEmpty="Aucune valise ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

              // No device available
              <InfosBar mode="row">
                <span>Aucune valise disponible</span>
              </InfosBar>

            )}


          </Section>

        </Container>

        {/* Clinic edit modal */}
        {this.state.showClinicEditModal &&
          <ModalClinic onClose={this.handleCloseClinicEditModal} clinic={clinic} />
        }

        {/* Clinic delete warning modal */}
        {this.state.showClinicDeleteModal &&
          <ModalOptions onClose={this.handleCloseClinicDeleteModal} icon="trash alternate" title="Suppression" message={<span>Vous êtes sur le point de supprimer ce client.<br />La réalisation de cette opération dissocieras les valises associées.<br /><br />Voulez vous continuer ?</span>} options={ModalOptions.OPTIONS_YESCANCEL} />
        }

        {/* Device link modal */}
        {this.state.showDeviceLinkModal &&
          <ModalLinkDevice onClose={this.handleCloseDeviceLinkModal} clinic={clinic} />
        }
      </React.Fragment>
    )
  }
}

export default withRouter(PaneInformations);
